import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import api from "../../services/api";
import { useWorkspace } from "../../utils/WorkspaceContext";
import useDebounce from "../../hooks/debounceHook";

const CreateSprintDialog = ({ open, onClose, onSuccess }) => {
  const [formData, setFormData] = useState({
    name: "",
    track: "",
    start_date: "",
    end_date: "",
  });
  const [tracks, setTracks] = useState([]);
  const { currentWorkspace } = useWorkspace();

  const debouncedCreateSprint = useDebounce(async (sprintData) => {
    try {
      await api.post("sprints/", sprintData);
      onSuccess();
    } catch (error) {
      console.error("Error creating sprint:", error);
    }
  }, 1000);

  useEffect(() => {
    const fetchTracks = async () => {
      try {
        const response = await api.get("tracks/", {
          params: { workspace_id: currentWorkspace.id },
        });
        setTracks(response.data);
      } catch (error) {
        console.error("Error fetching tracks:", error);
      }
    };

    fetchTracks();
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    formData.workspace = currentWorkspace.id;
    debouncedCreateSprint(formData);
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Create New Sprint</DialogTitle>
      <form onSubmit={handleSubmit}>
        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            label="Sprint Name"
            fullWidth
            required
            value={formData.name}
            onChange={(e) => setFormData({ ...formData, name: e.target.value })}
          />
          <Select
            margin="dense"
            label="Track"
            fullWidth
            required
            value={formData.track}
            onChange={(e) =>
              setFormData({ ...formData, track: e.target.value })
            }
          >
            {tracks.map((track) => (
              <MenuItem key={track.id} value={track.id}>
                {track.name}
              </MenuItem>
            ))}
          </Select>
          <TextField
            margin="dense"
            label="Start Date"
            type="date"
            fullWidth
            required
            value={formData.start_date}
            onChange={(e) =>
              setFormData({ ...formData, start_date: e.target.value })
            }
          />
          <TextField
            margin="dense"
            label="End Date"
            type="date"
            fullWidth
            required
            value={formData.end_date}
            onChange={(e) =>
              setFormData({ ...formData, end_date: e.target.value })
            }
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose}>Cancel</Button>
          <Button type="submit" variant="contained">
            Create
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default CreateSprintDialog;
